import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Input @type=\"checkbox\" @checked={{this.selected}} />",{ moduleName: "discourse/components/track-selected.hbs" })